<template>
  <div class="card h-100">
    <div class="card-body">
      <div class="row">
        <div class="col-8">
          <div class="text-xs text-uppercase text-primary text-bold mb-1">
            {{ header }}
          </div>
          <!--  eslint-disable-next-line vue/no-v-html -->
          <div v-if="title" class="pt-2 text-lighter">
            <i class="fa fa-clock"></i
            ><span class="ms-2 font-weight-bold">{{ formatDate(title) }}</span>
          </div>

          <div v-if="!hasData" class="text-muted py-3">
            No data found for the selected date.
          </div>

          <div v-show="hasData" class="pt-3 chart">
            <canvas :id="id" class="chart-canvas" :height="height"></canvas>
          </div>
        </div>

        <div
          v-if="alerts && alerts.length > 0"
          class="col-4"
          :style="`height: ${height}px; overflow-y:scroll`"
        >
          <div class="d-flex flex-column position-relative">
            <alert-score
              v-for="alert in alerts"
              :key="alert.key"
              :color="alert.color"
              :title="alert.title"
              :body="alert.body"
              :show-icon="alert.warning ? true : false"
              :filter-applied="filterApplied"
              :filter-key="filterKey"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import Constants from "@/helpers/constants";
import AlertScore from "@/shared/Cards/AlertScore.vue";

const dayjs = require("dayjs");

export default {
  name: "SectionChart",
  components: {
    AlertScore,
  },
  props: {
    id: {
      type: String,
      default: "section-chart",
    },
    header: {
      type: String,
      default: "Section Chart",
    },
    title: {
      type: Object,
      required: true,
    },
    height: {
      type: [String, Number],
      default: "200",
    },
    alerts: {
      type: Array,
      required: true,
    },
    filterApplied: {
      type: Boolean,
      required: true,
    },
    filterKey: {
      type: String,
      required: true,
    },
    chart: {
      type: Object,
      required: true,
      labels: Array,
      datasets: {
        type: Array,
        label: String,
        data: Array,
        color: String,
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    hasData() {
      return (
        this.chart && this.chart.datasets && this.chart.datasets.length > 0
      );
    },
  },
  watch: {
    chart() {
      this.addChart();
    },
  },
  methods: {
    formatDate(dt) {
      return dayjs(dt).format(Constants.DAY_OF_WEEK_TS_FORMAT);
    },
    addChart() {
      // Chart Consumption by day
      var ctx = document.getElementById(this.id).getContext("2d");

      let chartStatus = Chart.getChart(this.id);
      if (chartStatus != undefined) {
        chartStatus.destroy();
      }

      let chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.chart.labels,
          datasets: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                color: "#fff",
                boxWidth: 12,
                boxHeight: 12,
                padding: 40,
              },
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            x: {
              ticks: {
                color: "#95a7a3",
              },
            },
            y: {
              display: true,
              position: "left",
              min: 0,
              max: 100,
              ticks: {
                stepSize: 10,
                stepValue: 10,
                color: "#95a7a3",
              },
              title: {
                display: true,
                text: "SCORE",
                color: "#fff",
                font: {
                  family: "NotoSans-Regular",
                },
              },
            },
            y1: {
              display: true,
              position: "right",
              min: 0,
              max: 22,
              ticks: {
                stepSize: 2,
                color: "#95a7a3",
              },
              title: {
                display: true,
                text: "STRAIN",
                color: "#fff",
                font: {
                  family: "NotoSans-Regular",
                },
              },
              // grid line settings
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          },
        },
      });

      // add dataset
      this.chart.datasets.forEach((data, index) => {
        chart.data.datasets.push({
          categoryPercentage: 0.3,
          barPercentage: 1.0,
          label: data.label,
          data: data.data,
          backgroundColor: data.color,
          tension: 0.4,
          borderWidth: 0,
          borderRadius: 4,
          borderSkipped: false,
          maxBarThickness: 8,
          yAxisID: index == 2 ? "y1" : "y",
        });
      });
      chart.update();
    },
    filterTheTableByAlert(alertName, alertKey) {
      this.$parent.filterTheTableByAlert(alertName, alertKey);
    },
  },
};
</script>
